import React from 'react';
import StandardMarkdown from '@modules/ui/markdown/components/StandardMarkdown';
import DetailsSwaggerUIExecute from './DetailsSwaggerUIExecute';
import DetailsSwaggerUIOperation from './DetailsSwaggerUIOperation';
import DetailsSwaggerUILayout from './DetailsSwaggerUILayout';
import DetailsSwaggerUICurl from './DetailsSwaggerUICurl';

/**
 * Swagger UI Plugin for DetailsSwaggerUI
 * Provides the custom layout that uses OperationContainer and wraps the Operation component
 */
export const DetailsSwaggerUIPlugin = () => {
  return {
    components: {
      DetailsSwaggerUILayout,
      operation: DetailsSwaggerUIOperation,
      execute: DetailsSwaggerUIExecute,
      curl: DetailsSwaggerUICurl,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      Markdown: ({ source }: any) => {
        return <StandardMarkdown>{source}</StandardMarkdown>;
      },
    },
  };
};

export default DetailsSwaggerUIPlugin;
